module.exports = __webpack_public_path__ + "static/media/prosocialcommerce-logo-circle.d528d55a.svg";